import React, { useState } from 'react';
import { Modal, Button as Btn, Form, Input, Card, message } from 'antd';
import colors from '../../../../share/constants/constants';
import Close from './../../../../assets/icons/close.svg';
import Button from '../../../../components/common/button';
import {
  addBusinessType,
  approveBusiness,
  updateBusinessType,
} from '../../../../api/business';
import { useSelector } from 'react-redux';
import Dropdown from '../../../../components/common/dropdown';

const BusinessTypeFormModal = ({
  onCancel,
  data,
}) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);
  
  const onFinish = async (bTypeObj) => {
    setInProgress(true);
    if (data?._id) {
      if (!form.isFieldsTouched(['name', 'cost'])) {
        setInProgress(false);
        onCancel();
      } else {
        const res = await updateBusinessType(data._id, bTypeObj);
        if (res) {
          message.success('Business type updated successfully!');
          setInProgress(false);
          onCancel();
        }
        else{
          setInProgress(false);
        }
      }
    } else {
      const payload = {
        name: bTypeObj.name,
        cost: +bTypeObj?.cost,
        monthlyPrice: bTypeObj?.monthlyPrice
      };
      const res = await addBusinessType(payload);
      if (res) {
        message.success('Business type added successfully!');
        setInProgress(false);
        onCancel();
      }
      else {
        setInProgress(false);
      }
    }
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h2 className="flex-1">
              {data?._id ? `Edit` : `Add`} Business Type
            </h2>
            <img
              src={Close}
              alt="Cross Icon"
              className="w-3.2 hover:cursor-pointer"
              onClick={onCancel}
            />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="fex flex-col justify-center">
              <Form.Item
                name="name"
                rules={[
                  { required: data?._id ? false : true, message: 'Required' },
                ]}
              >
                <div>
                  <p className="text-1.4">Business Type Name</p>
                  <Input
                    placeholder={'e.g Fun Deals'}
                    defaultValue={`${data?.name || ''}`}
                    className={'w-full h-5.4 !rounded-xl border-unset'}
                  />
                </div>
              </Form.Item>
              <Form.Item
                name="cost"
                rules={[
                  { required: data?._id ? false : true, message: 'Required' },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  }
                ]}
              >
                <div>
                  <p className="text-1.4">Setup Cost ($)</p>
                  <Input
                    type="number"
                    className="flex items-center w-full h-5.4"
                    placeholder={`$ Setup Cost`}
                    defaultValue={`${data?.cost}`}
                  />
                </div>
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                title={data?._id ? `Update` : 'Save'}
                color={colors.primaryPurple}
                className="flex items-center w-full"
                htmlType="submit"
                onOk={onCancel}
                loading={inProgress}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default BusinessTypeFormModal;
